const INVALID_AUTHOR = /^(null(\s+null)?|undefined(\s+undefined)?)$/i;

/** Display name for an append-only admin comment entry (never editable/deletable). */
export function formatCommentAuthorLabel(entry) {
  const raw = entry?.byName != null ? String(entry.byName).trim() : '';
  if (raw && !INVALID_AUTHOR.test(raw)) return raw;
  const role = entry?.byRole != null ? String(entry.byRole).trim() : '';
  if (role) return role;
  return 'Admin';
}

const IST = 'Asia/Kolkata';

/** Format comment timestamp as "13 Oct 2026, 10:10 AM" in IST. */
export function formatCommentTimestamp(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const datePart = d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: IST
  });
  const timePart = d.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: IST
  }).toUpperCase();
  return `${datePart}, ${timePart}`;
}

export const formatCommentRelativeTime = formatCommentTimestamp;

